import { createStyles } from '@mantine/styles';

export default createStyles(() => ({
  close: {
    marginLeft: 'auto',
    marginRight: 0,
  },
}));
